import React, { useState } from "react";
import ManagerDashboardWapper from "../../../layout/wrapper/ManagerDashboardWapper";
import styles from "../../../styles/pages/user/memberpartner/partner-notification.module.scss";
import { Box, Paper, Stack } from "@mui/material";
import ManagerNotificationFilter from "../../../components/ManagerNotificationFilter/ManagerNotificationFilter";
import ManagerNotificationTab from "../../../components/ManagerNotificationTab/ManagerNotificationTab";
import MemberPartnerDashboardWrapper from "../../../layout/wrapper/MemberPartnerDashboardWrapper";
import PartnerNotificationTab from "../../../components/PartnerNotication/PartnerNoticationTab";
import PartnerNotificationFilter from "../../../components/PartnerNotificationFilter/PartnerNotificationFilter";
import useInfinitePost from "../../../hooks/api/useInfiniteFetch";
import axiosInstance from "../../../api/axiosInstance";
import ApiLoader from "../../../components/Loaders/ApiLoader";

export default function PartnerNotification() {
  const [date, setDate] = useState({ startDate: "", endDate: "", type: "" });
  console.warn("dateIs here", date);
  const [search, setSearch] = useState("");
  const [filterArchive, setFilterArchive] = useState(0);

  // notificationData
  //   filter
  const {
    data: partnerNotificationsList,
    isSuccess,
    isError,
    isLoading,
    refetch: refetchCopyNotifications,
    hasNextPage,
    isFetching,
    fetchNextPage,
  } = useInfinitePost(
    [
      "partnerNotification",
      filterArchive,
      date?.startDate,
      date?.endDate,
      search,
    ],
    `notifications`,
    {
      search: search,
      archive: filterArchive,
      from: date?.startDate,
      to: date?.endDate,
    }
  );

  // notificationData
  //   update copyWriteNotification
  const updateNotification = async (data) => {
    await axiosInstance
      .post("notification-status-update", data)
      .then((res) => {
        refetchCopyNotifications();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const updateNotificationSeen = (notification) => {
    updateNotification({
      notification_id: notification?.id,
      seen: notification?.seen ? 0 : 1,
    });
  };
  const updateNotificationArchive = (notification) => {
    updateNotification({
      notification_id: notification?.id,
      archive: 1,
    });
  };

  const updateNotificationReadAll = () => {
    updateNotification({ read_all: "yes" });
  };
  const updateNotificationArchiveAll = () => {
    updateNotification({ archive_all: "yes" });
  };
  const updateNotificationDelete = (notification) => {
    updateNotification({
      notification_id: notification?.id,
      delete: "yes",
    });
  };
  const updateNotificationDeleteAll = () => {
    updateNotification({ delete_all: "yes" });
  };
  return (
    <MemberPartnerDashboardWrapper chatbtn>
      <ApiLoader loading={isLoading || isFetching} />
      <Paper elevation={0} className={styles.pageManager}>
        <Stack
          direction="row"
          flexWrap="wrap"
          className={styles.notificationWrapper}
        >
          <PartnerNotificationFilter
            setSearch={setSearch}
            search={search}
            setDate={setDate}
            date={date}
          />
          <Box
            className={`${styles.tabsNotification} ${styles.tabpanelCenter}`}
          >
            <Box className={styles.tabsInner}>
              {isLoading &&
              !(
                search.length ||
                date.startDate.length ||
                date.endDate.length ||
                filterArchive
              ) ? (
                ""
              ) : isSuccess ||
                search.length ||
                date.startDate.length ||
                date.endDate.length ||
                filterArchive ? (
                <PartnerNotificationTab
                  search={search}
                  setSearch={setSearch}
                  date={date}
                  isLoading={isLoading}
                  partnerNotificationsList={partnerNotificationsList?.pages}
                  updateNotificationSeen={updateNotificationSeen}
                  updateNotificationArchive={updateNotificationArchive}
                  updateNotificationReadAll={updateNotificationReadAll}
                  updateNotificationArchiveAll={updateNotificationArchiveAll}
                  updateNotificationDelete={updateNotificationDelete}
                  updateNotificationDeleteAll={updateNotificationDeleteAll}
                  setFilterArchive={setFilterArchive}
                  hasNextPage={hasNextPage}
                  fetchNextPage={fetchNextPage}
                />
              ) : (
                ""
              )}
            </Box>
          </Box>
        </Stack>
      </Paper>
    </MemberPartnerDashboardWrapper>
  );
}
